export const buildPayload = (payload) => {
  const sanitizedPayload = {};
  Object.entries(payload).forEach(([key, value]) => {
    if (value !== null && value !== undefined && value !== "") {
      sanitizedPayload[key] = value;
    }
  });
  return sanitizedPayload;
};
